// Меню «Колонки»: галочки видимости и сброс вида. Было только на странице задач,
// причём собранное прямо в разметке страницы.
import type { ReactElement } from 'react';
import { Button, Checkbox, Dropdown } from 'antd';
import { useTranslation } from '@govard/i18n-core/react';

import type { GridProfile } from './useGridProfile.js';

interface GridColumnsButtonProps {
  profile: GridProfile;
  label?: string;
}

export function GridColumnsButton({ profile, label }: GridColumnsButtonProps): ReactElement {
  const { t } = useTranslation();
  const visibleLabel = label ?? t('crm.shared.columns');
  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: [
          ...profile.columns.map((column) => ({
            key: column.key,
            label: (
              <Checkbox
                checked={!profile.hidden.includes(column.key)}
                onClick={(event) => event.stopPropagation()}
                onChange={() => profile.toggleColumn(column.key)}
              >
                {column.label}
              </Checkbox>
            ),
          })),
          { type: 'divider' as const },
          { key: 'reset', label: t('crm.shared.reset_view'), onClick: () => profile.reset() },
        ],
      }}
    >
      <Button aria-label={t('crm.shared.configure_columns')}>{visibleLabel} ▾</Button>
    </Dropdown>
  );
}
